module.exports = __webpack_public_path__ + "media/images/themes/mcdonalds_culture_service/form_component_sprite_2x-410af1da37a9ef6d74148d0490f69301.png";